// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"8f47ea97","100":"96a26fb5","141":"9beefe69","161":"1faba2c4","305":"d11c8b58","705":"09850d43"}[chunkId] + ".chunk.css";
};